/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Method Not Allowed - Resource Deleted. Problem schema.
 */
export interface ProblemMethodNotAllowedResourceDeleted {
    actual: Truvity.Resource;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string;
    /** Optional list of individual error details */
    errors?: Truvity.ErrorDetail[];
    /** A URI reference that identifies the specific occurrence of the problem. */
    instance?: string;
    /** HTTP status code */
    status: number;
    /** This value should not change between occurrences of the error. */
    title: string;
}
